module.exports = __webpack_public_path__ + "plus-2021jump/images/spyfamily_01.a73d299.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/items/spyfamily_01.jpg
// module id = TS5+
// module chunks = 0